module.exports = "/_next/static/images/ty-332e8f225d2d7814f48dbdf4ca620106.png";